"use client";

import Image from "next/image";
import { useRef } from "react";
import { Typography } from "@drpcrd/shared/ui";
import {
  Carousel,
  CarouselAutoPlay,
  CarouselContent,
  CarouselItem,
} from "@drpcrd/shared/ui";
import { FadeInSection } from "../fade-in-section";
import channel4 from "./logos/logo_channel4.png";
import crocs from "./logos/logo_crocs.png";
import dhsc from "./logos/logo_dhsc.png";
import ee from "./logos/logo_ee.png";
import gdk from "./logos/logo_GDK.png";
import johnlewis from "./logos/logo_johnlewis.png";
import kallo from "./logos/logo_kallo.png";
import kelloggs from "./logos/logo_kelloggs.png";
import littlemoons from "./logos/logo_littlemoons.png";
import mcdonalds from "./logos/logo_mcdonalds.png";
import morrisons from "./logos/logo_morrisons.png";
import nivea from "./logos/logo_nivea.png";
import rescue from "./logos/logo_rescue.png";
import santander from "./logos/logo_santander.png";
import sky from "./logos/logo_sky.png";
import subway from "./logos/logo_subway.png";
import tacobell from "./logos/logo_tacobell.png";
import three from "./logos/logo_three.png";
import tiktok from "./logos/logo_tiktok.png";

const TRUST_LOGOS = [
  { name: "Channel 4", src: channel4 },
  { name: "Crocs", src: crocs },
  { name: "DHSC", src: dhsc },
  { name: "EE", src: ee },
  { name: "GDK", src: gdk },
  { name: "John Lewis", src: johnlewis },
  { name: "Kallo", src: kallo },
  { name: "Kellogg's", src: kelloggs },
  { name: "Little Moons", src: littlemoons },
  { name: "McDonald's", src: mcdonalds },
  { name: "Morrisons", src: morrisons },
  { name: "NIVEA", src: nivea },
  { name: "Rescue", src: rescue },
  { name: "Santander", src: santander },
  { name: "Sky", src: sky },
  { name: "Subway", src: subway },
  { name: "Taco Bell", src: tacobell },
  { name: "Three", src: three },
  { name: "TikTok", src: tiktok },
];

/**
 * "Running creator campaigns for" trust logo strip shown beneath the hero.
 * Renders as a stepped autoplay carousel.
 */
export const TrustLogos = () => {
  const autoplayPlugin = useRef(
    CarouselAutoPlay({
      delay: 2400,
      stopOnInteraction: false,
      stopOnMouseEnter: true,
    }),
  );

  return (
    <section className="relative px-3 pt-2 sm:px-6 md:px-8 lg:-mt-2 lg:pt-0">
      <div className="mx-auto max-w-5xl">
        <FadeInSection>
          <div>
            <Typography size="sm" align="center" className="leading-2.75">
              Trusted by agencies and brands
            </Typography>
            <Carousel
              opts={{ align: "start", loop: true, dragFree: false }}
              plugins={[autoplayPlugin.current]}
            >
              <CarouselContent className="ml-0">
                {TRUST_LOGOS.map((logo) => (
                  <CarouselItem
                    key={logo.name}
                    className="basis-1/6 pl-0 sm:basis-1/5 md:basis-[calc(100%/7)] lg:basis-[calc(100%/9)] xl:basis-1/10"
                  >
                    <div className="relative aspect-square w-full">
                      <Image
                        src={logo.src}
                        alt={logo.name}
                        fill
                        sizes="(min-width: 1280px) 10vw, (min-width: 1024px) 11.11vw, (min-width: 768px) 14.29vw, (min-width: 640px) 20vw, 16.67vw"
                        className="object-contain p-1"
                      />
                    </div>
                  </CarouselItem>
                ))}
              </CarouselContent>
            </Carousel>
          </div>
        </FadeInSection>
      </div>
    </section>
  );
};
